__turbopack_context__.v({
  "fade-in": "Ticks-module__upbFcW__fade-in",
  "tick": "Ticks-module__upbFcW__tick",
  "tickRow": "Ticks-module__upbFcW__tickRow",
});
